"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAction = void 0;
function getAction(client, action, name) {
  return params => {
    var _client, _client2;
    return (_client = (_client2 = client[action.name || name]) === null || _client2 === void 0 ? void 0 : _client2.call(client, params)) !== null && _client !== void 0 ? _client : action(client, params);
  };
}
exports.getAction = getAction;
//# sourceMappingURL=getAction.js.map